module.exports = __webpack_public_path__ + "img/3-Inserisci-codice.aba4d8bc.png";